module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w98"
  }, [_c('div', {
    staticClass: "crumb"
  }, [_c('span', [_c('router-link', {
    attrs: {
      "to": "/Help"
    }
  }, [_vm._v("帮助")]), _vm._v("  > ")], 1), _vm._v(" "), _c('span', [_vm._v("用户注册与登录")])]), _vm._v(" "), _c('help-Menu'), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rightContent"
  }, [_c('div', {
    staticClass: "conten"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v("打开网络浏览器，在地址栏输入相应地址，按回车键进入到本软件的登录界面（默认选中“远程教学系统”）。")]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("../../../../static/image/login.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("在上图中输入正确的手机号、密码、验证码，点击“登录”按钮。登录成功后，页面跳转到远程医学影像教育系统默认首页。")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-9c962b7a","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/moudle/UserMessage/UserMessage.vue
// module id = 590
// module chunks = 1 2 3 4 5 6 7 8